document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.size-guide-tabs__tab');
  const panels = document.querySelectorAll('.size-guide-tabs__panel');
  const EVENTS = ['click', 'keydown'];

  tabs.forEach(tab => {
    EVENTS.forEach(event => {
      tab.addEventListener(event, function () {
        if (event.type === 'keydown' && event.key !== 'Enter') return;
        const targetPanel = this.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        this.classList.add('active');
        document.querySelector(`[data-panel="${targetPanel}"]`).classList.add('active');
      });
    });
  });
});
